import { useState } from "react"

const CompanyAutoComplete = ({
  searchTerm,
  handleSearchChange,
  handleSelectCompany,
  companies = [],
  handleRemoveCompany = {},
  selectedCompanies = [],
  loading = false,
  loadingCompanies = false,
  errors = {},
  type = "multi-select",
  showDropdown = false,
  setShowDropdown
}) => {
  return (
    <div>
      {/* Search Input */}
      <div className="relative">
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          onFocus={() => setShowDropdown(true)}
          onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
          className={`w-full border rounded-lg px-3 py-2 ${errors?.company ? "border-red-500" : "border-gray-300"
            }`}
          placeholder="Search company..."
        />

        {/* Dropdown */}
        {showDropdown && searchTerm?.length >= 2 && (
          <div className="absolute z-10 w-full bg-white border rounded-lg mt-1 max-h-40 overflow-y-auto shadow">
            {loading ? (
              <p className="p-2 text-sm text-gray-400">Loading...</p>
            ) : companies.length === 0 ? (
              <p className="p-2 text-sm text-gray-400">
                No companies found
              </p>
            ) : (
              companies.map((comp) => (
                <div
                  key={comp.id}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => handleSelectCompany(comp)}
                  className="p-2 text-sm cursor-pointer hover:bg-gray-100"
                >
                  {comp.company_name}
                  {comp.location && (
                    <span className="text-gray-500 ml-1">
                      ({comp.location})
                    </span>
                  )}
                </div>
              ))
            )}
          </div>
        )}
      </div>

      {/* Multi Select Selected Companies */}
      {type === "multi-select" && (
        <div className="mt-3">
          {loadingCompanies ? (
            <p className="text-sm text-gray-400">Loading selected companies...</p>
          ) : (
            selectedCompanies.length > 0 ? (
              <div className="flex flex-wrap gap-2">
                {selectedCompanies.map((company) => (
                  <div
                    key={company.id}
                    className="flex items-center bg-blue-500 text-white px-3 py-1 rounded-full text-sm"
                  >
                    {company.company_name}
                    <button
                      type="button"
                      onClick={() => handleRemoveCompany(company.id)}
                      className="ml-2 text-white hover:text-red-200"
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-400">No company were assigned..</p>)
          )}
        </div>
      )}
    </div>
  )
}

export default CompanyAutoComplete